import { ERROR_MESSAGES } from './errorMessages';

const FALLBACK = 'Ocurrió un error. Intenta de nuevo.';

// Extraído de `getErrorMessage` para que los eventos de Socket.IO (que no pasan por
// `apiClient`/`ApiError` — ver `decorationSocket.js`) puedan resolver un código a texto de
// usuario con el mismo catálogo, sin duplicar el fallback.
export function getMessageForCode(code) {
    return (code && ERROR_MESSAGES[code]) || FALLBACK;
}

// Recibe directamente el ApiError que ya lanza shared/api/apiClient.js
// (`error.body` es el JSON parseado de la respuesta) —
// no hace falta cambiar apiClient.js. Un código sin traducción en ERROR_MESSAGES cae en el
// mensaje genérico — degradación segura mientras el catálogo del backend crece más rápido
// que el del frontend.
export function getErrorMessage(error) {
    return getMessageForCode(error?.body?.code);
}
